import {
  MODULES_FETCH_START,
  MODULES_FETCH_SUCCESS,
  MODULES_FETCH_ERROR,
  MODULE_SELECT,
} from "../types/modulesTypes";

const initialState = {
  list: [],
  selected: null,
  loading: false,
  error: null,
};

export default function modulesReducer(state = initialState, action) {
  switch (action.type) {
    case MODULES_FETCH_START:
      return { ...state, loading: true, error: null };

    case MODULES_FETCH_SUCCESS:
      return { ...state, loading: false, list: action.payload };

    case MODULES_FETCH_ERROR:
      return { ...state, loading: false, error: action.payload };

    case MODULE_SELECT:
      return { ...state, selected: action.payload };

    default:
      return state;
  }
}
